import Vue from "vue";
import Vuex from "vuex";
import syncOrder from "./module/syncOrder";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {},
  mutations: {},
  modules: {
    syncOrder,
  },
});
export default store;
